import React from 'react';
import { useIntl } from '@kyruus/intl';
import { Select } from '@biome-design-system/ui/Select';

import { DISTANCE_ANY } from './index';
import { messages } from '../../messages';

export interface DistanceProps {
  distance: string | number;
  distanceOptions: (string | number)[];
  onChange: (distance: string | number) => void;
}

export const Distance = ({
  distance,
  distanceOptions,
  onChange
}: DistanceProps) => {
  const intl = useIntl();
  return (
    <Select
      label={intl.formatMessage(messages.within)}
      id="location-filter-distance"
      name="location-filter-distance"
      data-testid="location-filter-distance"
      size="small"
      sx={{
        width: 'fit-content',
        '& .MuiSelect-select.MuiSelect-select': { minWidth: 'fit-content' }
      }}
      slotProps={{ inputLabel: { sx: { textIndent: 'unset' } } }}
      onChange={(event) => onChange(event.target.value)}
      value={distance}
      aria-label={intl.formatMessage(messages.within_aria_label)}
      options={(distanceOptions || []).map((distance) => ({
        value: distance,
        label:
          distance === DISTANCE_ANY
            ? intl.formatMessage(messages.anymiles)
            : intl.formatMessage(messages.numericalmiles, { distance })
      }))}
    />
  );
};
